import React, { useState } from 'react';
import { exportTicketsToCSV } from '../utils/ticketUtils';

function ExportButton({ tickets, boards, style = {} }) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      
      // Add a small delay to show loading state
      await new Promise(resolve => setTimeout(resolve, 500));
      
      const timestamp = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      const filename = `tickets_export_${timestamp}.csv`;
      
      exportTicketsToCSV(tickets, filename);
      
      // Show success message
      alert(`✅ Successfully exported ${tickets.length} tickets to ${filename}`);
      
    } catch (error) {
      console.error('Export error:', error);
      alert('❌ Error exporting tickets. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  const defaultStyle = {
    backgroundColor: tickets.length === 0 ? '#6c757d' : '#28a745',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    color: 'white',
    fontWeight: 'bold',
    cursor: tickets.length === 0 ? 'not-allowed' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '14px'
  };

  const buttonStyle = { ...defaultStyle, ...style };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting || tickets.length === 0}
      style={buttonStyle}
      title={tickets.length === 0 ? 'No tickets to export' : `Export ${tickets.length} tickets to CSV`}
    >
      {isExporting ? (
        <>
          <span style={{ 
            width: '12px', 
            height: '12px', 
            border: '2px solid white', 
            borderTop: '2px solid transparent', 
            borderRadius: '50%', 
            animation: 'spin 1s linear infinite' 
          }}></span>
          Exporting...
        </>
      ) : (
        <>
          Export CSV ({tickets.length})
        </>
      )}
    </button>
  );
}

export default ExportButton;